<template>
  <div class="buy-airtime">
  	<div style="position: fixed; top: 50%; left: 50%; z-index: 999;">
      <atom-spinner
        v-if="loading"
        :animation-duration="speed"
        :size="config.size"
        :color="spinnersColor"
      />
    </div>
    <div class="mb-3" v-if="processingError">
      <va-notification color="danger" closeable>       
        An error occurred! Please Try again later.
      </va-notification>
    </div>
    <div class="row">
	      <div class="flex xs12 md6" v-if="AirtimeForm">
	      	<p class="flex xs12 md12">Buy Airtime</p>
	      	 <va-card :title="$t('menus.buy-airtime')">
	          <form @submit.prevent="onsubmit">
	            

	            <va-input
	              :label="$t('amount')"
	              type="number"
	              v-model="formdata.amount"
	              :error="!!amountErrors.length"
	              :error-messages="amountErrors"
	            />         
	            <va-input              
	              :label="$t('recieving_phone_no')"
	              v-model="formdata.recieving_phone_no"           
	              :error="!!phoneErrors.length"
	              :error-messages="phoneErrors"
	            />	

						<div class="row mt-5">            
							<va-button type="submit" >
							{{ $t('forms.controls.submit') }}
							</va-button>                        
						</div>
	          </form>
	      	 </va-card>   
	      </div>
				<div class="flex xs12 md6" v-if="VasForm">
	      	<p class="flex xs12 md12">Service Payment</p>
	      	 <va-card :title="$t('menus.buy-airtime')">
	          <form @submit.prevent="onsubmit">
	            

	            <va-input
	              :label="$t('amount')"
	              type="number"
	              v-model="formdata.amount"
	              :error="!!amountErrors.length"
	              :error-messages="amountErrors"
	            />         
	            <va-input              
	              :label="$t('account_no')"
	              v-model="formdata.account_no"           
	              :error="!!AccountErrors.length"
	              :error-messages="AccountErrors"
	            />	

						<div class="row mt-5">            
							<va-button type="submit" >
							{{ $t('forms.controls.submit') }}
							</va-button>                        
						</div>
	          </form>
	      	 </va-card>   
	      </div>	 			
	 			<div class="flex xs12 md6">
	 				<div class="row">
	 				<p class="flex xs12 md12">Kenya Power</p>	     
		      <div class="flex xs6 md4">
		        <va-card  color="info" :style="{'background-image': 'url(' + require('../../assets/imgs/tokens.png') + ')'}"  style="height: 200px; width: 200px;">	 
		        	<div class="row mt-4">
			          <va-button color="info"  @click="vas_Pay('KPLC_PREPAID')">
			            KPLC Tokens
			          </va-button>
			        </div>        
		        </va-card>
		      </div>

		      <div class="flex xs6 md4">
		        <va-card  color="info" :style="{'background-image': 'url(' + require('../../assets/imgs/tokens.png') + ')'}"  style="height: 200px; width: 200px;">	 
		        	<div class="row mt-4">
			          <va-button color="info" @click="vas_Pay('KPLC_POSTPAID')">
			            KPLC Post-Paid
			          </va-button>
			        </div>        
		        </va-card>
		      </div>
	        </div>
	      </div>
	    </div>
     <div class="row">
      	<p class="flex xs12 md8">T.V Subscriptions</p>
      	<p class="flex xs12 md4">Water Service</p>
      	<div class="flex xs12 md8">
      		<div class="row">
			      <div class="flex xs6 md3">
			        <va-card  color="info" :style="{'background-image': 'url(' + require('../../assets/imgs/dstv.png') + ')'}"  style="height: 200px; width: 200px;">	 
			        	<div class="row mt-4">
				          <va-button color="info" @click="vas_Pay('DSTV')">
				            Pay Dstv
				          </va-button>
				        </div>        
			        </va-card>
			      </div>

			      <div class="flex xs6 md3">
			        <va-card  color="info" :style="{'background-image': 'url(' + require('../../assets/imgs/gotv.png') + ')'}"  style="height: 200px; width: 200px;">	 
			        	<div class="row mt-4">
				          <va-button color="info" @click="vas_Pay('GOTV')">
				            Pay Gotv
				          </va-button>
				        </div>        
			        </va-card>
			      </div>

			      <div class="flex xs6 md3">
			        <va-card  color="info" :style="{'background-image': 'url(' + require('../../assets/imgs/zuku.png') + ')'}"  style="height: 200px; width: 200px;">	 
			        	<div class="row mt-4">
				          <va-button color="info" @click="vas_Pay('ZUKU')">
				            Pay Zuku
				          </va-button>
				        </div>        
			        </va-card>
			      </div>

			      <div class="flex xs6 md3">
			        <va-card  color="info" :style="{'background-image': 'url(' + require('../../assets/imgs/start.png') + ')'}"  style="height: 200px; width: 200px;">	 
			        	<div class="row mt-4">
				          <va-button color="info" @click="vas_Pay('STARTIMES')">
				             Pay Startimes
				          </va-button>
				        </div>        
			        </va-card>
			      </div>
			    </div>
		    </div>
		   
		    <div class="flex xs12 md4">
		    	<div class="row">
		    	  <div class="flex xs6 md4">
			        <va-card  color="info" :style="{'background-image': 'url(' + require('../../assets/imgs/water.png') + ')'}"  style="height: 200px; width: 200px;">	 
			        	<div class="row mt-4">
				          <va-button color="info" @click="vas_Pay('NAIROBI_WTR')">
				            Pay Nairobi Water
				          </va-button>
				        </div>        
			        </va-card>
			      </div>
			    </div>
		    </div>
      </div>
		
    
    <va-modal
      v-model="showConfirmModal"
      position="top"
      size = "medium"
      :title=" $t('confirm_trans')"
      cancelClass="none"      
      :okText=" $t('modal.confirm') "     
      :cancelText=" $t('modal.cancel')"      
      noOutsideDismiss
      noEscDismiss
      @ok = "FinalPost"
    >
      <table class="va-table va-table--striped va-table--hoverable" width="100%">
        <tbody>
          <tr v-if="AirtimeForm">
            <td>Recieving Phone No.</td>
            <td style="text-align: right;">{{ phone_no }}</td>
          </tr>

          <tr v-if="AirtimeForm">
            <td>Airtime amount</td>
            <td style="text-align: right;">{{ payment_amount | Currency }}</td>
          </tr>         
          <tr v-if="AirtimeForm">
            <td>Transaction Charge</td>
            <td style="text-align: right;">{{ charge | Currency }}</td>
          </tr>      

          <tr v-if="VasForm">
            <td>Service.</td>
            <td style="text-align: right;">{{ trans }}</td>
          </tr>

          <tr v-if="VasForm">
            <td>Account No.</td>
            <td style="text-align: right;">{{ account_no }}</td>
          </tr>

          <tr v-if="VasForm">
            <td>Amount</td>
            <td style="text-align: right;">{{ payment_amount | Currency }}</td>
          </tr>         
          <tr v-if="VasForm">
            <td>Transaction Charge</td>
            <td style="text-align: right;">{{ charge | Currency }}</td>
          </tr>             
        </tbody>
      </table>
    </va-modal>

   
  </div>
</template>
<script>
import axios from 'axios'
import * as spinners from 'epic-spinners'

export default {
	components: {
	...spinners      
	},
	name: 'buy-airtime',
	data () {
		return {
			userData: JSON.parse(localStorage.getItem('LoggedUser')),
			token: JSON.parse(localStorage.getItem('Token')),	
			loading: false,
			loadSelect:false,
			processingError: false,	
			AirtimeForm:true,
			VasForm:false,
			charge:0,			
			finalPost : '',
			formdata:{				
				recieving_phone_no:'',
				amount:'',
				account_no:'',				       
				user: '',
				type: '',
				trans: '',
			},
			amountErrors : [],			
			phoneErrors: [],
			AccountErrors:[],
			payment_amount : 0,
			phone_no: '',	
			account_no:'',		
			showConfirmModal : false,
			showVasModal:false,
			vasTrans:'none',
			config: {
				size: 80,
				duration: 1500,
			},
			spinnersColor: this.$themes.secondary,
			currentDuration: 1500,
			sliderDuration: {
				min: 1000,
				max: 2000,
			}      
		}
	},
	computed: {
	    speed () {
	    	return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
	    },

	    formReady () {
	    	return !this.amountErrors.length && !this.phoneErrors.length
	    },
	},
	methods : {
	  onsubmit () {	       
      this.processingError = false;
      this.amountErrors = this.formdata.amount ? [] : ['Amount is required'];

      if(this.AirtimeForm){
      	this.phoneErrors = this.formdata.recieving_phone_no ? [] : ['Phone No. is required'];
      	this.formdata.type = 'Airtime';
      }
      if(this.VasForm){
      	this.AccountErrors = this.formdata.account_no ? [] : ['Account No.'];
      	this.formdata.type = 'Vas';
      	this.formdata.trans = this.trans;
      }

      if (this.formReady) {
        this.loading = true	       
        var self = this

        let config = {
          headers: {
            Authorization: this.userData.user_id+' '+this.token
          }
        }

        axios.post(`${this.$apiUrl}BuyAirtime`, this.formdata, config)
        .then(function (res) {            
        	self.loading = false
        	const response = res.data          			
        	if (response.status == false) {
        		self.amountErrors =  response.message_code;
        		self.phoneErrors = response.message_code;
        	}

        	if(response.status == true){           
            self.payment_amount = self.formdata.amount
            self.phone_no = self.formdata.recieving_phone_no
            self.account_no = self.formdata.account_no
            self.showConfirmModal = true;
	        }
	        console.log(self.account_no); 
        })
        .catch(function (error) {
            console.log(error)
        })
      }
		},

		FinalPost () {		      
		    this.loading = true
		    var self = this

		    let config = {
          headers: {
            Authorization: this.userData.user_id+' '+this.token
          }
        }

		    axios.post(`${this.$apiUrl}BuyAirtimefinal`, this.formdata, config)
		      .then(function (res) {
		        self.loading = false
		        const resp = res.data
		        if(resp.success == true){              
		          self.showToast(`Payment Processed succefully`, {
		            position: 'bottom-right',
		            icon: "fa-check",
		            duration: 2500,
		          })
		          setTimeout( () => self.$router.go(-1), 2500);
		        } else {
		          self.processingError = true
		        }
		                  
		      })
		      .catch(function (error) {
		          console.log(error)
		      })
		},

		vas_Pay(payment){
			console.log(payment);
			this.trans = payment;
			console.log(this.trans);
			this.VasForm = true;
			this.AirtimeForm =false;
			//this.showVasModal = true;
		},

		payVas(){
			
		}
	}, 
	created () {
	    this.formdata.user  = this.userData.user_id
	}
}
</script>